import type { FC } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import type { DetailedFollowUpTicket } from 'src/types/followUp';
import type { SurveyDetail } from 'src/types/survey';

import ModalSection from '../ModalSection';

import FeedbackSection from './FeedbackSection/FeedbackSection';
import OrgUnitSection from './OrgUnitSection/OrgUnitSection';

const RespondentOverviewSection: FC<{
  ticket: DetailedFollowUpTicket;
  survey?: SurveyDetail;
}> = ({ ticket, survey }) => {
  const [extended, setExtended] = useState(true);
  const { t } = useTranslation('followUp');

  return (
    <ModalSection
      header={t('respondent')}
      extendable={{
        extended: extended,
        toggleExtended: () => setExtended((prev) => !prev),
      }}
    >
      <OrgUnitSection ticket={ticket} />
      <FeedbackSection ticket={ticket} survey={survey} />
    </ModalSection>
  );
};

export default RespondentOverviewSection;
